import EmptyStateNotice from '@/components/EmptyStateNotice';
import DetailsError from '@/components/modals/workflowLogsModal/DetailsError';
import DetailsHeader from '@/components/modals/workflowLogsModal/DetailsHeader';
import DetailsInfoSection from '@/components/modals/workflowLogsModal/DetailsInfoSection';
import DetailsLogSection from '@/components/modals/workflowLogsModal/DetailsLogSection';
import WorkflowLogsModalSummary from '@/components/modals/workflowLogsModal/WorkflowLogsModalSummary';
import ReplayFooterBar from '@/screens/workflows/workflowLogs/ReplayFooterBar';
import ReplayModeBanner from '@/screens/workflows/workflowLogs/ReplayModeBanner';
import { FiAlertCircle } from '@/components/react-icons/main';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors';

const WorkflowLogsModalDetails = () => {
  const activeLogId = useArgSelector(selectors.query, 'logId');
  const log = useArgSelector(selectors.workflowLogsById, activeLogId);
  const isLoadingLogById = useArgSelector(selectors.isLoading, 'getWorkflowLogById');
  const isReplayMode = useArgSelector(selectors.query, 'replayMode') === 'true';

  if (activeLogId === 'summary') {
    return (
      <div className="workflow-logs-modal-details">
        <WorkflowLogsModalSummary />
      </div>
    );
  }

  if (!log && !isLoadingLogById) {
    return (
      <div className="workflow-logs-modal-details">
        <EmptyStateNotice title="Log not found" description="The requested workflow log could not be found or may have been deleted." icon={FiAlertCircle} />
      </div>
    );
  }

  if (!log && !isLoadingLogById) {
    return null;
  }

  const details = (
    <div className="workflow-logs-modal-details">
      <DetailsHeader />
      {isReplayMode ? <ReplayModeBanner /> : <DetailsInfoSection />}
      <DetailsError />
      <DetailsLogSection />
    </div>
  );

  // In replay mode the footer bar lives outside the scrolling pane so it sits
  // flush with the modal's bottom edge; non-replay mode keeps the bare pane.
  if (isReplayMode) {
    return (
      <div className="workflow-logs-modal-details-column">
        {details}
        <ReplayFooterBar />
      </div>
    );
  }

  return details;
};

export default WorkflowLogsModalDetails;
